import {createAsyncThunk} from '@reduxjs/toolkit';
import PlatformApi from 'src/api/PlatformApi';
import Logger from 'src/logging/Logger';
import {GiftItem as GiftItemType} from 'src/types/snack/GiftItem';
import {RootState} from '../../store';

export type LoadGiftFeedResponse = {
  items: GiftItemType[];
  metadata: {
    pagination: {
      currentPage: number;
      limit: number;
      nextOffset: number;
      offset: number;
      pageCount: number;
      previousOffset: number | null;
      totalCount: number;
    };
    sortedBy: [];
  };
  offset: number;
  limit: number;
};
export type LoadGiftFeedParams = {
  locationId: string;
  offset?: number;
  limit?: number;
};
export const loadGiftFeed = createAsyncThunk<
  LoadGiftFeedResponse,
  LoadGiftFeedParams,
  {state: RootState}
>(
  'snack/loadGiftFeed',
  async ({locationId, offset = 0, limit = 10}, {getState}) => {
    const accountId = getState().account.account.id;

    const response = await PlatformApi.fetchSnacks(
      locationId,
      offset,
      limit,
      accountId,
    );
    Logger.Log.LogAPIEvent(
      'PlatformAPI',
      'FetchSnacks',
      JSON.stringify({locationId, offset, limit, accountId}),
      JSON.stringify(response),
    );

    return {
      ...response,
      offset,
      limit,
    };
  },
);
